import { ICellRendererParams } from "ag-grid-community";
import { useGetContainerStatusQuery } from "../../store/apiSlices/containerTracking";
import { SpinnerIcon } from "../Icons";

export default function ETACellRenderer(props: ICellRendererParams) {
  const { data: containerStatusData, isLoading } = useGetContainerStatusQuery(
    { row_id: props.data.row_id! },
    {
      skip:
        !props.data.container_tracking.column_value ||
        !props.data.logistics_provider.column_value,
    }
  );

  if (isLoading)
    return (
      <div className="flex items-center gap-1">
        <SpinnerIcon className="size-4 text-gray-200 animate-spin fill-blue-600" />
        <p>loading..</p>
      </div>
    );

  if (containerStatusData?.status === "fail") return <p>No data</p>;

  return <div>{containerStatusData?.data?.response?.stats?.best_case_eta}</div>;
}
